import Divider from "../../common/Divider";
import SectionTitle from "../../common/SectionTitle";
import DataTable from "../../common/DataTable";
import Button from '../../common/Button';

const Info = () => {

    return (
        <section className='container text-center mx-auto grid grid-cols-1 md:grid-cols-2 py-24 p-10'>
            <div className="w-full flex flex-col items-center md:items-start md:text-left md:block">
                <SectionTitle text={"Onderdelen Lidgeld:"} light={false}/>
                <Divider/>
                <p className="py-4">
                    Het lidgeld bestaat uit een bijdrage voor de club, en eventuele extra bijdrages (Boogsport
                    Vlaanderen, Huur Boog, ...):
                    <br /><br />
                    Het sportjaar loopt telkens vanaf 1 september tot en met 31 augustus.
                </p>
                <SectionTitle text={"Bijdrage voor de Club:"} light={false}/>
                <Divider/>
                <DataTable
                    heading={['', 'Tarief Sportjaar', 'Tarief 2de helft sportjaar (01/03 t.e.m 31/08)']}
                    rows={[
                        ['Volwassenen', '€ 70,-', '€ 45,-'],
                        ['Jeugd of Student *', '€ 50,-', '€ 30,-'],
                    ]}
                />
                <p>* Jeugd tot 18 jaar; studenten zolang men studeert én fiscaal ten laste is van de ouder(s)</p>
                <br/>
                <SectionTitle text={"(Optioneel) Huur Boog:"} light={false}/>
                <Divider/>
                <DataTable
                    heading={['', 'Tarief Sportjaar', 'Tarief 2de helft sportjaar (01/03 t.e.m 31/08)']}
                    rows={[
                        ['Iedereen', '€ 65,-',  '€ 35,-']
                    ]}
                />
                <SectionTitle text={"(Optioneel) Boogsport Vlaanderen:"} light={false}/>
                <Divider/>
                <DataTable
                    heading={['', 'Tarief Sportjaar **']}
                    rows={[
                        ['U18 tot 60+', '€ 50,- ***'],
                        ['U13 tot U15', '€ 33,- ***'],
                        ['Familietarief', '€ 80,-']
                    ]}
                />
                <p>** Het sportjaar van BSV loopt van 1 oktober tot 30 september.</p>
                <p>*** Standaard BSV tarief, verminderd met € 10 tussenkomst van Robin Hood Boechout.</p>
                <br/>
                <SectionTitle text={"(Optioneel) Antwerpse Federatie:"} light={false}/>
                <Divider/>
                <DataTable
                    heading={['', 'Tarief']}
                    rows={[
                        ['Lidgeld ****', '€ 3,-']
                    ]}
                />
                <p>**** Opgepast, de AF opereert in een grijze zone, zij hebben géén verzekering voor hun wedstrijden/organisatie.</p>
                <br/>
            </div>
            <div className="w-full">
                <Button className='block md:hidden' text={'Lid worden'} link={'https://www.mijnassist.be/NL/389eab02-d01a-48d9-ba2e-1f2925de63a6/waitinglist/subscribe'} />
                <iframe title='Inschrijvingsformulier' className='w-full h-3/4 hidden md:block' src="https://www.mijnassist.be/NL/389eab02-d01a-48d9-ba2e-1f2925de63a6/waitinglist/subscribe"></iframe>
                {/*<p className='italic w-3/4 text-center m-auto text-sm p-4'>Zodra je inschrijving goedgekeurd is, sturen we je het betaalverzoek op. Soms mist die z’n doel en belandt 'ie in je spamfolder, dus hou zowel je inbox als je spam goed in het vizier! 🏹</p>*/}
                <p className='italic w-3/4 text-center m-auto text-sm p-4'>Gelieve uw lidgeld over te schrijven op rekeningnummer <b>BE86 0010 5626 7150</b>. Vermeld bij de overschrijving steeds duidelijk uw naam en de gekozen formules in detail.
                    <br />
                    <u>Voorbeeld van mededeling:</u>
                    <br />
                    Markey Tom – Volw + BSV + Boog + AF</p>
            </div>
        </section>
    );
};

export default Info;